module.exports = __webpack_public_path__ + "static/media/JINDALSTEL.744c8a4b.txt";